const MoreLink = () => {

    const more_link = document.querySelector('[data-more]');

    if (typeof more_link != 'undefined' && more_link != null) {

        const more_info = document.querySelector('[data-more-content]');

        more_link.addEventListener('click', event => {
            
            event.preventDefault();
            more_link.classList.add('tabs__more--hidden');

            if (typeof more_info != 'undefined' && more_info != null) {
                more_info.classList.add('tabs__activities-wrap--active');
            }
            
        });
    }

}

export default MoreLink;